<template>
    <b-card class="card-centered" id="procesamientoCompra">
        <div class="text-center" v-if="isProcessing">
            <b-spinner label="Loading..." variant="primary" />
            <b-card-text>
                <b>Estamos procesando tu compra. </b>
                <hr>
                <small>Por favor, espera un momento...</small>
            </b-card-text>
        </div>
    </b-card>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import { notify } from '@/js/utils.js';
import direccionEnvio from './direccionEnvioArchetype';
import contrataYa from './contrataYa';
import stripeObj from './../stripeHandler.js';

export default {
    name: 'procesamientoCompra',
    props: {
        threeDSecureTimeout: {
            type: Number,
            default: 1000 * 4 * 1 // 4 segundos
        },
        pmSelected: {
            type: String,
            required: true
        },
        getBack: {
            type: Function,
            default: () => { }
        },
        timeoutWait: {
            type: Number,
            default: 3000
        }
    },
    data() {
        return {
            isProcessing: true,
            stripe: null
        };
    },
    methods: {
        async makePurchase() {
            try {
                let data2send = _.cloneDeep(contrataYa.workingData);
                data2send.workAddress = direccionEnvio.workAddress;
                let response = await axios.post('ventasesim/comprayadiferred', data2send);
                if (!_.isObjectLike(response))
                    throw 'La respuesta no es un objeto válido.';

                // Si hay un mensaje, lo muestra al usuario. 
                if (response.msg)
                    notify(response.msg, response.class);

                // Error en la compra
                if (!response.status)
                    this.getBack();

                // Espera adicional en caso de que el pago no se haya completado (3D Secure)
                if (response.data.is3DSecure) 
                    await new Promise(resolve => setTimeout(resolve, this.threeDSecureTimeout));

                // Compra realizada con éxito o activación de 3D Secure
                if (response.data.isPaid || (response.data.is3DSecure && await this.processSuscriptionOBJ(response.data)) || response.status)
                    this.$router.replace({ name: 'mis-suscripciones', params: { suscId: response.data.suscriptionUserID } });

            } catch (error) {
                notify(error, 'error')
                console.error('Error processing purchase:', error);
                this.getBack()
            } finally {
                this.isProcessing = false;
            }
        },
        async processSuscriptionOBJ(suscriptionOBJ) {
            // Logic to handle the suscriptionOBJ
            const confirmResult = await this.stripe.confirmCardPayment(suscriptionOBJ.clientSecret, {
                payment_method: this.pmSelected,
            });

            // Revisión de estatus del pago
            if (!confirmResult.paymentIntent) {
                notify('Confirmación incompleta, puedes finalizarla en el botón de "Finalizar pago" de la siguiente ventana.', 'error');
            } else if (confirmResult.paymentIntent.status == 'succeeded') {
                notify('Confirmación completa, pago realizado con éxito.', 'success');
            } else if (confirmResult.paymentIntent.error) {
                notify(confirmResult.paymentIntent.error.message, 'error');
            } else {
                notify('No se pudo completar el pago, puedes concretarlo en el botón de "Finalizar pago" de la siguiente ventana.', 'error');
            }
            
            return true;
        }
    },
    beforeMount() {
        this.stripe = stripeObj.initialize();
    },
    mounted() {
        setTimeout(this.makePurchase, this.timeoutWait);
    }
}
</script>

<style lang="scss">
#procesamientoCompra {}
</style>